export default [
  {
    id: 1,
    text: "html",
  },
  {
    id: 2,
    text: "css",
  },
  {
    id: 3,
    text: "javascript",
  },
  {
    id: 4,
    text: "node.js",
  },
  {
    id: 5,
    text: "react",
  },
]
